// ported from src/web/style/_ol-colours.scss

export const OL_COLOUR_CTA_PINK = '#D3277E';
export const OL_COLOUR_KELP = '#0B808D';
export const OL_COLOUR_NAVY_BABY = '#094967';
export const OL_COLOUR_MELON = '#00874D';
export const OL_COLOUR_TOMAHTO = '#DC2A2A';

export const OL_COLOUR_BLACK_90 = 'rgba(0, 0, 0, 0.9)';
export const OL_COLOUR_BLACK_80 = 'rgba(0, 0, 0, 0.8)';
export const OL_COLOUR_BLACK_55 = 'rgba(0, 0, 0, 0.55)';
export const OL_COLOUR_BLACK_25 = 'rgba(0, 0, 0, 0.25)';
export const OL_COLOUR_BLACK_10 = 'rgba(0, 0, 0, 0.1)';
export const OL_COLOUR_BLACK_4 = 'rgba(0, 0, 0, 0.04)';

export const OL_COLOUR_BLACK_90_HEX = '#1A1A1A';
export const OL_COLOUR_BLACK_80_HEX = '#333333';
export const OL_COLOUR_BLACK_55_HEX = '#737373';
export const OL_COLOUR_BLACK_25_HEX = '#BFBFBF';
export const OL_COLOUR_BLACK_10_HEX = '#E5E5E5';
export const OL_COLOUR_BLACK_4_HEX = '#F5F5F5';

export const OL_COLOUR_HIGHLIGHT = 'rgba(0, 121, 177, 0.06)';

export const OL_COLOUR_ACCESSIBLE_THEME_COLOURS = [
  '#766E71',
  '#9F6144',
  '#262626',
  '#25443E',
  '#0B4F19',
  '#2F3A4B',
  '#004F3B',
  '#00516D',
  '#002F81',
  '#001944',
  '#002F44',
  '#2D3B64',
  '#2B185C',
  '#3E2F62',
  '#4C3488',
  '#2E0053',
  '#54095F',
  '#780044',
  '#6D2D6D',
  '#00737D',
  '#203551',
  '#490007',
  '#391109',
  '#007771',
];

export const OL_COLOUR_NEW_PINK = '#CF1B53';

export const OL_COLOUR_DANGER = '#D9534F';

export const OL_COLOUR_ORANGE_WARNING = '#FF9900';

export const OL_HOVER_LIGHTEN_AMOUNT = 0.2;
export const OL_HOVER_DARKEN_AMOUNT = 0.2;
